import { render } from "./ProductDetailsView.vue?vue&type=template&id=37fc02f8"
import script from "./ProductDetailsView.vue?vue&type=script&lang=js"
export * from "./ProductDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_a183cd1461c0af2cd22f865d8ad5d3fd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__